import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { useHistory } from 'react-router-dom';
import {
  DashboardOutlined,
  FundProjectionScreenOutlined,
  PartitionOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { CollapseType } from 'antd/lib/layout/Sider';
// import './SiderMenu.less';

const { SubMenu } = Menu;

const { Sider } = Layout;

type SiderMenuProps = {

  collapsed: boolean;
  handleOnCollapse: () => void;


};
const SiderMenu: React.FC<SiderMenuProps> = ({
  collapsed, handleOnCollapse
}) => {
  //const SiderMenu = (collapsed:boolean,handleOnCollapse:() => void)  =>{
  const theme = 'light';

  const history = useHistory();



  

  const handleSiderMenuClick = (action: any) => {
    console.log('menu:', action);
    switch (action.key) {
      case 'dashboard':
        history.push('/');
        break;
      case 'showProducts':
        history.push('/products');
        break;
      // case 'addProduct':
      //   history.push('/add-product');
      //   break;
      case 'showCustomers':
        history.push('/customers');
        break;
      case 'showCompanys':
        history.push('/companys');
        break;

      case 'showDivisions':
        history.push('/divisions');
        break;

      case 'showDepartments':
        history.push('/departments');
        break;

      case 'showCars':
        history.push('/cars');
        break;
      case 'showEmployees':
        history.push('/employees');
        break;
      // case 'addCustomer':
      //   history.push('/add-customer');
      //   break;
      default:
        history.push('/');
    }
  };

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="80"
      onCollapse={handleOnCollapse}
      collapsed={collapsed}
      width="200"
      theme={theme}
      
    >
      <a>
        <div className="menu-logo" />
      </a>
      <Menu mode="inline" theme={theme} onClick={handleSiderMenuClick}>
        {/* <Menu.Item key="dashboard">
          <DashboardOutlined />
          <span className="nav-text">Dashboard</span>
        </Menu.Item> */}

      
        <Menu.Item key="showCars">
          <SettingOutlined />
          <span className="nav-text">CAR</span>
        </Menu.Item>

        {/* <SubMenu
          key="customers"
          title={
            <span>
              <TeamOutlined />
              <span>Master Data</span>
            </span>
          }
        >
          <Menu.Item key="showCustomers">
            <span className="nav-text">Customers</span>
          </Menu.Item>
          <Menu.Item key="showProducts">
            <span className="nav-text">Products</span>
          </Menu.Item>
          <Menu.Item key="showCompanys">
            <span className="nav-text">Companys</span>
          </Menu.Item>
          <Menu.Item key="showDivisions">
            <span className="nav-text">Divisions</span>
          </Menu.Item>
          <Menu.Item key="showDepartments">
            <span className="nav-text">Departments</span>
          </Menu.Item>
          <Menu.Item key="showEmployees">
            <span className="nav-text">Employees</span>
          </Menu.Item>
          
        </SubMenu>
        <Menu.Item key="settings">
          <SettingOutlined />
          <span className="nav-text">Settings</span>
        </Menu.Item>
        <Menu.Item key="reports">
          <FundProjectionScreenOutlined />
          <span className="nav-text">Reports</span>
        </Menu.Item> */}
      </Menu>
    </Sider>
  );
}

export default SiderMenu;